import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { contactFaqs } from '@/mocks/contactData';

export default function ContactFaq() {
  const [openId, setOpenId] = useState<string | null>(contactFaqs[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Good To Know"
          title="Frequently Asked Questions"
          description="Quick answers to the questions our partners and customers ask us the most."
        />

        <div className="mt-10 md:mt-14 max-w-3xl mx-auto space-y-3">
          {contactFaqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(faq.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                      {faq.question}
                    </span>
                    <span
                      className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                    </span>
                  </button>
                </h3>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}